import React from 'react';
import Configurer from '../../components/Configurer';
// import { checkTextTranslation } from '../../utils/useful'
import FormViewer from '../../components/FormViewer';
import LoaderButton from '../../components/LoaderButton';
import Responsive from '../../components/Responsive';
import { imageAddress, translate } from '../../utils/useful';
import { siteConfig, siteTheme } from '../../variables/config';
import ButtonAnimated from '../../components/buttons/ButtonAnimated';
import CAHeader from '../../components/header/CAHeader';
import { countriesList } from '../../variables/countries';
const { timeZone } = Intl.DateTimeFormat().resolvedOptions();

export default class CHInfo extends React.Component {

    state = {
        formHeaders: [
            // { key: 'image', type: 'ProfileImageInput', theme: 'transparent', information: { label: '{{lang}}image', placeholder: '{{lang}}image', placeHolderImage: '', inputClass: 'none', required: false, cropper: true, ratio: '1:1', single: true } },
            // { key: 'name', type: 'TextInput', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
            // { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}description', placeholder: '{{lang}}description', required: false } },

        ]
    }

    componentDidMount() {
        // if (this.setHeader) {
        //     // this.props.setHeader("dummy",1)
        //     this.setHeader({
        //         'toolbar': null,
        //         'showToolbar': false,
        //         // 'title': `${this.props.user?.info?.fullname}`,
        //         'info': 'Create Hub | Info',
        //         topHeaderComponent: this.topHeaderComponent,
        //         backAction: () => this.props.lastStage()

        //     })
        // }
        this.props.showHeader(true, () => {

            if (this.props.setHeader) {
                // this.props.setHeader("dummy",1)
                this.props.setHeader({
                    'toolbar': null,
                    'showToolbar': false,
                    // 'title': `${this.props.user?.info?.fullname}`,
                    isPortal: true,
                    doNotshowNotification: true,
                    showSettings: false,
                    create: true,
                    'title': "{{lang}}Create Hub | Info",
                    topHeaderComponent: this.topHeaderComponent,
                    backAction: () => this.props.lastStage()
                })
            }
        })

        // console.log(timeZone)


        let countries = countriesList
        let formHeaders = []
        let countriesItems = []
        let currenciesItems = []
        countries.forEach(country => {
            let countryItem = { title: country.name, value: country.code }
            let currencyItem = { title: `${country.currency} (${country.symbol})`, value: country.code }
            // let title = country.name
            // let value = country.code
            countriesItems.push(countryItem)
            currenciesItems.push(currencyItem)
        });

        let header = [
            { key: 'image', type: 'ProfileImageInput', theme: 'transparent', information: { label: '{{lang}}image', placeholder: '{{lang}}image', placeHolderImage: '', inputClass: 'none', required: false, cropper: true, ratio: '1:1', single: true } },
            { key: 'name', type: 'TextInput', information: { label: '{{lang}}name', placeholder: '{{lang}}name', required: true } },
            { key: 'description', type: 'TextAreaInput', information: { label: '{{lang}}About', placeholder: '{{lang}}Write about your hub', required: false } },

            { key: 'country', type: 'SelectInput', information: { label: 'Country', type: 'local', items: countriesItems, placeholder: '{{lang}}Country', required: true } },
            {
                key: 'currency', type: 'SelectInput', information: { label: 'Currency', type: 'local', items: currenciesItems, placeholder: '{{lang}}Currency', required: true },
                dependencies: [{
                    refKey: 'country', targetKey: 'currency',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: '@data.country' }, operator: { value: '!=' }, target: { value: null } } }, },
                        effect: { show: true, changeValue: true }
                    }],
                    else: { show: true, changeHeader: [{}] },
                    init: true,
                    // show:true,

                }]
            }]
        formHeaders = header

        this.setState({ formHeaders })

    }

    setHeader = (key, value) => {
        if (this.header) {
            if (typeof key == 'object') {
                let object = {
                    showSettings: true,
                    showFrames: 'static'
                }
                if (this.props.defaultHeaderConfig) {
                    object = { ...this.props.defaultHeaderConfig }
                }
                for (const [okey, ovalue] of Object.entries(key)) {
                    object[okey] = ovalue
                }
                if (object.showSettings && this.props.showSettings) {
                    object.showSettings = this.props.showSettings
                }
                this.setState({ headerConfig: object }, () => {
                    this.header.forceUpdate()
                })
            }
            else {
                this.setState({ headerConfig: { ...this.state.headerConfig, [key]: value } }, () => {
                    this.header.forceUpdate()
                })
            }
        }
    }

    topHeaderComponent = () => {
        return (
            <div className='flexc'>

                <ButtonAnimated
                    iconwidth='24px'
                    isLoading={this.state.isLoading}
                    onClick={this.nextClicked}
                    title={translate("Next Step")}
                    icon='/assets/icons/angle-right-white2.svg'
                    textColor={'#222'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }

    nextStage = (cb) => {
        // this.setState({ isLoading: true, errors: {} })
        if (this.form) {
            let data = this.form.getForm()
            console.log(data)
            return
            if (data) {
                window.scrollTo(0, 0)

                this.props.setData(data, () => {
                    // this.props.postUserInfo((result, err) => {
                    // if (err) { this.setState({ errors: err }) }
                    // this.setState({ isLoading: false })
                    this.props.nextStage()

                    // })
                })
            }
        }
    }


    formLiveChange = (data) => {

        if (data?.name && data?.name != '') {
            this.setState({ canContinue: true })
        } else {
            this.setState({ canContinue: false })
        }
    }


    nextClicked = () => {
        let form = this.form.getForm()
        if (form && this.state.canContinue) {

            this.props.setData(form, () => {
                this.props.changeStage("username")
            })

        }
    }



    render() {
        return (



            <div className=" w-100 h-100 position-relative window-content-radius" style={{ backgroundColor: '#f5f5f5' }}>
                {/* <div className='w-100' style={{ position: 'sticky', top: 0 }}>
                    <CAHeader ref={el => this.header = el} config={this.state.headerConfig} toolbar={this.state.toolbar} showToolbar={this.state.showToolbar} type={'static'} functionsHandler={this.functionsHandler} page={this.state.page} language={this.props.language} toolbarView={'applet'} headertype={'applet'} headers={this.state.headers} goToHub={this.props.goToHub} backStage={this.backStage} sections={this.state.sections} modules={this.state.modules} changePage={this.changePage} backbtn={this.state.showBackBtn} applet={this.props.applet} width={this.props.width} colors={this.props.colors} features={this.props.applet?.features} />
                </div> */}
                <div className='flexcc w-100 h-100  scroll-no-scrollbar ' style={{ }}>

                    <Responsive width={this.props.width} height="100%" media={{ xs: "12", sm: '12', md: '12', lg: "12", xl: "12" }}>
                        <div className=' w-100 flexc flex-column pb-5' style={{ padding: '0px 4%' }}>
                            <div className='w-100 pt-4' style={{ maxWidth: 500 }} >

                                {/* <div style={{ position: '', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}>
                                    <div className='px-2 pb-2 flexcb back-blur pt-0 w-100 pt-2' >
                                        <div>
                                            <div className='flexc  p'>
                                                <div className='flexcc' style={{ backgroundColor: '#78419230', height: 24, width: 24, borderRadius: 20 }}>
                                                    <p className=' text-bold' style={{ color: '#24113C' }}>2</p>
                                                </div>
                                                <h2 className="mt-0 text-normal mb-0 mx-2" style={{ color: '#24113C' }} >{translate('Create Hub | Info')}</h2>
                                            </div>
                                            <div style={{ maxWidth: 450 }}>
                                            <p className="mt-1 text-smaller opacity-7" style={{ color: '#3C3811' }} >{translate("Hub type does not limit you in it's usage, it just helps us to recommend you better solutions")}</p>
                                        </div>
                                        </div>


                                        <div className='flexc'>

                                            <button onClick={() => this.props.lastStage()} className="text-small mx-2" >
                                                <img className='rotate-180' src='/assets/icons/angle-right.svg' height={18} />
                                            </button>

                                            <div className='mx-1'>
                                                <button onClick={() => this.props.lastStage()} className='px-1 py-1  flexcc' style={{ filter: 'saturate(20%) ', background: 'linear-gradient(to right, #CD64FE, #FE6481)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>

                                                    <div className='flexcc rotate-180 p-1' style={{ borderRadius: 10 }}>
                                                        <img className='invert rtl-button' src='/assets/icons/angle-right.svg' height={18} />
                                                    </div>
                                                </button>
                                            </div>


                                            <div>
                                                <button onClick={() => this.nextClicked()} className='px-1 py-1  flexcc' style={{ filter: !this.state.canContinue ? 'saturate(20%) ' : '', background: 'linear-gradient(to right, #CD64FE, #FE6481)', borderRadius: 10, color: '#fff', transition: 'all 0.5s' }}>
                                                    <p className='text-small text-semibold mld-3 mrd-3 ' style={{ whiteSpace: 'nowrap' }}>{translate("Next Step")}</p>

                                                    <div className='flexcc mld-3 p-1' style={{ background: 'linear-gradient(to right, #ffffff10, #ffffff20)', borderRadius: 10 }}>
                                                        <img className='invert rtl-button' src='/assets/icons/angle-right.svg' height={18} />
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='px-1'>
                                        <div className='w-100 ' style={{ backgroundColor: '#fff', height: 16, borderRadius: '16px 16px 0px 0px', transform: 'translateY(1px)', marginTop: -1 }}></div>
                                    </div>
                                </div> */}


                                <div className='px-1 ' style={{ marginTop: 0 }}>
                                    <div className='px-2 pt-1 pb-4 br-10' style={{ backgroundColor: '#fff', boxShadow: '0px 0px 30px #10101020', position: 'relative', zIndex: 5 }}>
                                        <div className='mb-3 px-3 mt-3'>
                                            <p className='weight-600 '>{translate("Insert hub information")}</p>
                                            <p className='font-size-14 weight-400 mt-1'>{translate("This information will be publicly available and it helps people find your hub")}</p>
                                        </div>
                                        <div className='d-flex flex-wrap'>
                                            <FormViewer ref={el => this.form = el} headers={this.state.formHeaders} initData={this.props.initData} errors={this.state.errors} formClass={"bordered-form"} inputClass={'bordered-input'} liveChange={this.formLiveChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Responsive>


                    {/* <Responsive width={this.props.width} height="100%" media={{ xs: "none", sm: '4', md: '4', lg: "6", xl: "6" }}>

                        <div className="text-center" style={{ minHeight: '100vh', position: 'relative', top: 0, padding: '100px 30px 20px 30px', backgroundPosition: 'center', backgroundSize: 'cover' }}>


                            <div className='flexc flex-column' style={{ position: 'sticky', top: 70 }}>
                                <img className=" mb-2" src={'/assets/icons/portals/Asset 2.svg'} width={'90px'} />
                                <p className="text-big text-bold">{translate("Create Hub").toUpperCase()}</p>
                                <p className=" text-smaller" style={{ maxWidth: '300px' }} >{translate("Description about new hub and the terms of use will be shown here")}</p>
                            </div>
                        </div>

                    </Responsive> */}

                </div>


            </div>


        )
    }
}